import { render } from "./ListOfMovementBySelected.vue?vue&type=template&id=106cc818&scoped=true"
import script from "./ListOfMovementBySelected.vue?vue&type=script&lang=js"
export * from "./ListOfMovementBySelected.vue?vue&type=script&lang=js"

import "./ListOfMovementBySelected.vue?vue&type=style&index=0&id=106cc818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106cc818"]])

export default __exports__